import { TrashIcon } from "@heroicons/react/24/solid";
import { Card, Typography } from "@material-tailwind/react";
import { Link } from "react-router-dom";
 
const TABLE_HEAD = ["Name", "Price", "Type", "Location","Edit","Delete"];
 
const TABLE_ROWS = [
  
];

const PropertyList = ({properties,deleteProperty}) => {
  return (
    <div className='ml-[20rem]  ' >
    <h3 className="py-2 text-[1.3rem]" >Properties</h3>
        <Card className="h-full w-full overflow-scroll">
      <table className="w-full min-w-max table-auto text-left">
        <thead>
          <tr>
            {TABLE_HEAD.map((head) => (
              <th key={head} className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                <Typography
                  variant="small"
                  color="blue-gray"
                  className="font-[NeueMedium] leading-none opacity-70"
                >
                  {head}
                </Typography>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {properties.map((property, index) => {
            const isLast = index === TABLE_ROWS.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";
 
            return (
              <tr key={property?.name}>
                <td className={classes}>
                  <Typography variant="small" color="blue-gray" className="font-[NeueRegular]">
                    {property?.name}
                  </Typography>
                </td>
                <td className={`${classes} bg-blue-gray-50/50`}>
                  <Typography variant="small" color="blue-gray" className="font-[NeueRegular]">
                    {property?.price}
                  </Typography>
                </td>
                <td className={classes}>
                  <Typography variant="small" color="blue-gray" className="font-[NeueRegular]">
                    {property?.type}
                  </Typography>
                </td>
                <td className={classes}>
                  <Typography variant="small" color="blue-gray" className="font-[NeueRegular]">
                    {property?.location}
                  </Typography>
                </td>
                <Link to={`/property/${property?.id}`} >
                <td className={`${classes} bg-blue-gray-50/50`}>
                  <Typography as="a" href="#" variant="small" color="blue-gray" className="font-[NeueRegular] text-blue-400">
                    Edit
                  </Typography>
                </td>
                </Link>
                <td className={`${classes} 0`}>
                  <Typography onClick={()=>deleteProperty(property?.id)} as="a" href="#" variant="small" color="blue-gray" className="font-medium">
                    <TrashIcon className="w-[20px] text-red-600" />
                  </Typography>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Card>
    </div>
  )
}

export default PropertyList